import store from './index';

import CampaignMessageService, { CampaignViewTableType } from '../services/CampaignMessageService';
import { CampaignMessage } from '../models';

export interface CampaignMessageFilters {
  campaignId: string;
  page: number;
  pageSize: number;
  orderBy: string;
  orderDesc: boolean;
  type: CampaignViewTableType;
}

export interface CampaignMessageState {
  campaignMessages: CampaignMessage[];
  count: number;
  loading: boolean;
  filters: CampaignMessageFilters;
}

export const CampaignMessageModule = {
  state: {
    campaignMessages: [],
    count: 0,
    loading: false,
    filters: '',
  },
  mutations: {
    setCampaignMessageLoading(state: CampaignMessageState, loading: boolean) {
      state.loading = loading;
    },
    setCampaignMessages(state: CampaignMessageState, campaignMessage: CampaignMessage[]) {
      state.campaignMessages = campaignMessage;
    },
    setCampaignMessagesCount(state: CampaignMessageState, count: number) {
      state.count = count;
    },
    setCampaignMessagesFilters(state: CampaignMessageState, filters: CampaignMessageFilters) {
      state.filters = filters;
    },
  },
  actions: {
    async loadCampaignMessages({commit}: any, campaignId: string) {
      const campaignMessages = await CampaignMessageService.getAllCampaignMessages(campaignId);
      commit('setCampaignMessages', campaignMessages);
    },
    async refreshCampaignMessagesByType({commit}: any) {
      store.dispatch('loadCampaignMessagesByType', store.state.campaignMessage.filters);
    },
    async loadCampaignMessagesByType(
      {commit}: any,
      payload = {
        page: 1, pageSize: 10, orderBy: '', orderDesc: false, campaignId: '', type: '',
      },
    ) {
      commit('setCampaignMessages', []);
      commit('setCampaignMessageLoading', true);
      const result = await CampaignMessageService.getAllCampaignMessagesByType(
        payload as any,
      ).finally(() => {
        commit('setCampaignMessageLoading', false);
      });
      commit('setCampaignMessagesCount', result.count);
      commit('setCampaignMessages', result.results);
    },
  },
};
